import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom';

const PageTransition = ({ children }) => {
    const location = useLocation();
    const [elementStyle, setElementStyle] = useState({}); // State to manage styles

    useEffect(() => {
        const stylesOpacityZero = {
            opacity: 0,
          };
          setElementStyle(stylesOpacityZero);
          
        const stylesOpacityOne = {
            opacity: 1,
          };
          setTimeout(() => {
              setElementStyle(stylesOpacityOne);
          }, 350);
      
    },[location])
    return (
    <div className='pagetransition' style={elementStyle}>{children}</div>
  )
}

export default PageTransition